function Button({ children, variant = 'primary', size = 'md', onClick, className = '', type = 'button', ...props }) {
  const baseStyles = 'rounded-lg font-medium transition-colors disabled:opacity-20 disabled:cursor-not-allowed';

  const sizeStyles = {
    xs: 'py-1 px-3 text-[10px] min-h-[24px]',
    sm: 'py-1 px-2 text-[11pt]',
    md: 'py-2 px-4 text-xs',
  };

  const variants = {
    primary: 'bg-primary-blue text-white',
    // 이름은 'black'(레거시)이지만 실제 색은 accent 오렌지. 순수 검정은 다크 배경(#1E1E1E)과
    // 거의 구분이 안 돼 버튼이 안 보이는 문제가 있어 바꿈. 89개 파일이 이 variant를 쓰고
    // 있어서 이름은 그대로 두고 스타일만 교체(각 파일 prop 변경 불필요).
    black: 'bg-accent text-white hover:bg-accent-dark',
    gray: 'bg-neutral-500 text-white',
    nobg: 'bg-transparent text-text-dark',
    red: 'bg-red-500 text-white hover:bg-red-600',
    redoutline: 'bg-white text-red-500 border border-red-500',
    outline: 'bg-white text-text-dark border border-neutral-500 hover:bg-gray-50',
    facebook: 'bg-primary-facebook text-white hover:opacity-90 flex items-center justify-center gap-2',
    line: 'bg-primary-green text-white hover:bg-green-600 flex items-center justify-center gap-2',
    google: 'bg-white text-text-dark border border-border-gray hover:bg-gray-50 flex items-center justify-center gap-2',
    email: 'bg-white text-text-dark border border-border-gray hover:bg-gray-50 flex items-center justify-center gap-2',
  };

  return (
    <button
      type={type}
      className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
